import React from 'react';

import { useCurrentUserPermissions, useCurrentUserStaff } from 'src/hooks/user';

import { useEmployerById } from './useEmployerById';

export const useCurrentUserEmployer = () => {
  const { employerStaff } = useCurrentUserStaff();
  const { hasEmployerRoles } = useCurrentUserPermissions();

  const employerId = React.useMemo(() => {
    if (!hasEmployerRoles) return null;
    return employerStaff?.employer.id;
  }, [employerStaff?.employer.id, hasEmployerRoles]);

  return useEmployerById(employerId);
};
